import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form'
import {Row, Form,Divider,Tag } from 'antd';

import {RTLCol,RTLButton} from '../RTLKit';


/* ------ Field -------- */
import TextField from '../formFields/TextField';
import SelectField from '../formFields/SelectField';
import SelectFieldByTag from '../formFields/SelectFieldByTag';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import Loading from "../loading/loading";

class WarehouseAddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: 'add',
            productId: this.props.match.params.product_id ? this.props.match.params.product_id : '',
            rowType: '',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            role  :this.props.userValue ? this.props.userValue.rl : null,
            count : 0,
            showTechnicianCount : false,
            showStateCount : false,
            userLists: this.props.userList
        };
        this.props.setProductId(this.state.productId);

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        this.props.getAreaList();
        this.props.getUserList({role:"TECHNICIAN",size:100});
        this.props.getProductInfo(this.state.productId);
        this.props.getCountProduct('central', this.state.productId)
        if (this.props.match.params.id){
            let id = this.props.match.params.id;
            this.props.getItem(id)
        }
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __getUserList() {
        let userList = this.props.userList;
        let dataSource = [];

        if (userList && userList.lists) {

            for (let i = 0; i < userList.lists.length; i++) {

                if(userList.lists[i].role == "TECHNICIAN" && userList.lists[i].is_active === true)
                    dataSource.push(
                        {label: userList.lists[i].name+' '+userList.lists[i].family, value: userList.lists[i]._id, key: i}
                    );

            }

        }
        return dataSource;
    }

    onChange(type){
        this.setState({rowType : type});
        if(type === 'CENTRAL_WAREHOUSE') {
            this.props.getCountProduct('central', this.state.productId);
        }
    }

    stateOnChange(stateId){
        this.setState({showStateCount : true})
        this.props.getCountProduct('state', this.state.productId,stateId);
    }

    technicianOnChange(technicianId){
        this.setState({showTechnicianCount : true})
        this.props.getCountProduct('technician', this.state.productId,'',technicianId);
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;
        if(this.props.productInfo)
            var productName = this.props.productInfo.title;

        var centralCount = this.props.centralCount
        let stateCount = 0
        let technicianInfo = this.props.technicianCount
        let technicianCount = 0;
        let technicianStateCount = 0;
        let technicianStateName = 0;
        if(this.props.stateCount)
            stateCount = this.props.stateCount
        if(this.props.technicianCount) {
            technicianCount = technicianInfo.technician_inventory
            technicianStateCount = technicianInfo.technician_state_inventory
            technicianStateName = technicianInfo.technician_state_title
        }


        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">ایجاد انبار برای {productName}</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                             <Field
                                name="count"
                                component={TextField}
                                type="number"
                                label="تعداد"
                                placeholder="تعداد"
                            />
                            <Field
                                name="assign_type"
                                component={SelectField}
                                label="نوع عملیات"
                                placeholder="نوع عملیات"
                                list={[
                                    {label: 'تخصیص', value: 'ADD_WAREHOUSE', key: 1},
                                    {label: 'برگشت', value: 'REMOVE_WAREHOUSE', key: 2}
                                ]}
                            />
                            <Field
                                name="row_type"
                                component={SelectFieldByTag}
                                label="نوع انبار"
                                placeholder="نوع انبار"
                                list={[
                                    {label: 'مرکزی', value: 'CENTRAL_WAREHOUSE', key: 1},
                                    {label: 'استان', value: 'STATE_WAREHOUSE', key: 2},
                                    {label: 'تکنسین', value: 'TECHNICIAN_WAREHOUSE', key: 3}
                                ]}
                                onChange = {this.onChange.bind(this)}
                                tag={<Tag color="green" className="productCount">تعداد موجودی انبار مرکزی : {centralCount}</Tag>}
                            />

                            {(this.state.rowType && (this.state.rowType == 'STATE_WAREHOUSE') )?
                            <Field
                                name="stateId"
                                component={SelectFieldByTag}
                                label="استان"
                                placeholder="استان"
                                list={this.__getAreaStateList()}
                                onChange = {this.stateOnChange.bind(this)}
                                tag={(this.state.showStateCount ? <Tag color="cyan" className="productCount">تعداد موجودی : {stateCount}</Tag> : '')}
                            />

                            :null }
                            {(this.state.rowType && this.state.rowType == 'TECHNICIAN_WAREHOUSE' )?
                            <Field
                                name="technicianId"
                                component={SelectFieldByTag}
                                label="انتخاب تکنسین"
                                placeholder="انتخاب تکنسین"
                                list={this.__getUserList()}
                                onChange = {this.technicianOnChange.bind(this)}
                                tag={(this.state.showTechnicianCount ? <Tag color="blue" className="productCount">تعداد موجودی تکنسین : {technicianCount} تعداد موجودی استان {technicianStateName} : {technicianStateCount}</Tag> : '')}
                            />
                            :null }
                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/product/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default WarehouseAddEditForm = reduxForm({
    form: 'addWarehouse',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(WarehouseAddEditForm)
